export type OnceFlag = {
  attempt: () => boolean;
  reset: () => void;
};

export const createOnceFlag = (): OnceFlag => {
  let used = false;
  return {
    attempt: () => {
      if (used) return false;
      used = true;
      return true;
    },
    reset: () => {
      used = false;
    }
  };
};
